import { render } from "./remmentest.vue?vue&type=template&id=bbe82c30"
import script from "./remmentest.vue?vue&type=script&lang=js"
export * from "./remmentest.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-sections/remmentest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbe82c30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbe82c30', __exports__)) {
    console.log('reload')
    api.reload('bbe82c30', __exports__)
  }
  
  module.hot.accept("./remmentest.vue?vue&type=template&id=bbe82c30", () => {
    console.log('re-render')
    api.rerender('bbe82c30', render)
  })

}


export default __exports__